import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  BaseBackResponse,
  Intervention,
  WorkType,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}TechnicalIntervention`;

interface CreateTechnicalInterventionCommandPayload {
  fileId: string;
  startDateTime: string | Date;
  endDateTime: string | Date;
  assignedToIds?: string[];
  preciseStartTime?: string | Date;
  preciseEndTime?: string | Date;
  workType?: WorkType;
  description?: string;
}

const createTechnicalInterventionCommand = async (
  payload: CreateTechnicalInterventionCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<Intervention>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default createTechnicalInterventionCommand;
